import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/OrganizeDeskGame/scenes/GameIntro';

interface PhaserOrganizeDeskGameProps {
    onComplete: () => void;

}

interface PhaserOrganizeDeskGameState {
}

const gameConfig: GameConfig = {
    title: "Desk Cleaning Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#000000",
};

class PhaserOrganizeDeskGame extends React.Component<PhaserOrganizeDeskGameProps, PhaserOrganizeDeskGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserOrganizeDeskGameProps) {
        super(props);
        bindAllOfThis(this, PhaserOrganizeDeskGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig}  onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserOrganizeDeskGame;



// WEBPACK FOOTER //
// ./src/games/OrganizeDeskGame/Main.tsx